import { render, staticRenderFns } from "./DocumentsSendMailForm.vue?vue&type=template&id=2a69975d"
import script from "./DocumentsSendMailForm.vue?vue&type=script&lang=js"
export * from "./DocumentsSendMailForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports